<section class="section">
  <div class="complex__content-wrapper complex-flat__wrapper">

    <div class="not-found__wrapper">

      <div class="not-found__title">
        <div class="not-found__title-one">404</div>
        <div class="not-found__title-two">Страница не существует</div>
        <div class="not-found__title-three">
          Вы попытались перейти на несуществующую страницу. <br>
          Вы можете перейти на <a href="/">главную страницу</a> или выберите ниже нужный вам раздел. <br>
          Или позвоните нам по номеру <a href="tel:+74959884422">+7 (495) 988-44-22</a> и мы обязательно вам поможем.
        </div>
      </div>

        <!--блок с картинкой и анимацией-->
        <div class="not-found__animation">

        <!--город-->
        <div class="not-found__animation-frame not-found__animation-frame--city"></div>
        <!--End город-->

        <!--машинка-->
        <div class="not-found__animation-frame not-found__animation-frame--car"></div>
        <!--END машинка-->

        <!--первая пара облаков-->
        <div class="not-found__animation-frame not-found__animation-frame--clouds-one"></div>
        <!--END первая пара облаков-->

        <!--вторая пара облаков-->
        <div class="not-found__animation-frame not-found__animation-frame--clouds-two"></div>
        <!--END вторая пара облаков-->
        </div>
      <!--END блок с картинкой и анимацией-->

        </div>

      <!--Список ссылок на другие разделы-->

      <div class="not-found__list js-not-found-links">

        <ng-container *ngFor="let bottomLinkItem of bottomLinksList">
          <a href="{{ bottomLinkItem.link }}" class="not-found__list-item not-found__list-item--{{ bottomLinkItem.prefix }}">
            <span class="not-found__list-title">{{ bottomLinkItem.title }}</span>
            <span class="not-found__list-link">{{ bottomLinkItem.linkText }}</span>
          </a>
        </ng-container>
      </div>
      <!--END список ссылок на другие разделы-->

    </div>
</section>
